import React from 'react';
import { isNull } from 'lodash';

import CardLayout from '@magoosh/layouts/card';
import { SecondaryButton } from '@magoosh/lib/button';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { paths } from 'config/path_helpers';

import { ScoreReportResponse } from '@magoosh/test_prep/app/pages/score_reports/types';

import BadgeCheck from './assets/badge_check.svg';

export default (props: ScoreReportResponse) => {
  return (
    <CardLayout.Card borderGradient className="d-flex flex-column gap-m">
      <div className="align-items-center d-flex gap-xxs">
        <h3 className="align-items-center d-flex gap-xs u-margin-A-n">
          Score
          
          {(() => {
            if (props.status === 'finished') {
              return <strong>{isNull(props.score) ? 'NS' : props.score}</strong>;
            } else if (props.status === 'processing') {
              return (
                <FontAwesomeIcon
                  className="fa-spin small"
                  icon="refresh"
                  style={{ color: '#2A6EB6' }}
                />
              );
            } else {
              return null;
            }
          })()}
        </h3>

        {
          !isNull(props.score) && props.scoreSource && (
            <div className="align-items-center d-flex flex-1 gap-xs justify-content-end">
              {props.scoreSource.official && <img alt="" src={BadgeCheck} width="20" />}
              <div className="text-bold tiny">Scored by {props.scoreSource.name}</div>
            </div>
          )
        }
      </div>

      <div className="d-flex flex-column flex-sm-row gap-s gap-sm-l">
        <div className="flex-1">
          {(() => {
            if (props.answer.examSection.subject === 'speaking') {
              return "Your score report has a full breakdown, including sub-scores, AI feedback on your strengths/weaknesses, and the option to try again."
            } else if (props.answer.examSection.subject === 'writing') {
              return "Your score report has a full breakdown, including AI feedback on your strengths/weaknesses and suggested edits to improve your writing."
            } else {
              return "Your score report has a full breakdown, including AI feedback on your strengths and weaknesses."
            }
          })()}
        </div>

        <div>
          <SecondaryButton href={paths.scoreReportAnswer(props.gradingRequestId, props.answer.id)}>
            View Score Report
          </SecondaryButton>
        </div>
      </div>
    </CardLayout.Card>
  );
};
